import axios from 'axios';

import {baseURL} from '../config';

const _axios = axios.create({
  baseURL
});

export default _axios;
